import React from "react";
import "./ForMen.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/* 🔥 REQUIRED IMPORTS */
import products from "../../data/products";
import ReviewSlider from "../ReviewSlider";
import FeaturesSection from "../FeaturesSection";
import BlogSection from "../BlogPage";

const ForMen = () => {
  /* ✅ FILTER ONLY MEN PRODUCTS */
  const menProducts = products.filter((item) => item.category === "men");

  return (
    <>
      {/* ✅ SEO META */}
      <Helmet>
        <title>
          Buy Men Pleasure Products Online in India | Discreet Delivery – LushDesire
        </title>
        <meta
          name="description"
          content="Shop premium men pleasure products online in India. Explore masturbators, pocket pussy, sex dolls, condoms & accessories with 100% discreet delivery from LushDesire."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://lushdesire.in/men" />
      </Helmet>

      <section className="men-page">
        <div className="container">
          {/* ✅ H1 MAIN PAGE HEADING */}
         <h1 className="men-title">
  Buy Men Masturbators, Sex Dolls & Pleasure Products Online in India – Discreet Delivery
</h1>

{/* ✅ H2: Product Grid Section */}
<div className="men-intro" style={{ textAlign: "center", margin: "40px 0" }}>
  <h2>
    Best Men Sex Products Online in India
  </h2>
  <p>
    Shop men pleasure products in India – masturbators, sex dolls, condoms & accessories with discreet delivery.
  </p>
</div>


          <div className="men-grid">
            {menProducts.map((item) => (
              <div className="men-card" key={item.id}>
                <img
                  src={process.env.PUBLIC_URL + item.image}
                  alt={`${item.name} for men with discreet delivery in India`}
                  loading="lazy"
                />

                {/* ✅ H3: Product Name */}
                <h3 className="product-name">{item.name}</h3>

                {/* ✅ H4: Price Info */}
                <div className="price-box">
                  {item.mrp > item.price && <span className="mrp">₹{item.mrp}</span>}
                  <span className="price">₹{item.price}</span>
                </div>

                {/* ✅ H5: CTA Button */}
                <Link to={`/product/${item.slug}`} className="order-btn">
                  Order Now
                </Link>
              </div>
            ))}
          </div>

          {/* ✅ SAFETY CHECK */}
          {menProducts.length === 0 && (
            <p style={{ textAlign: "center" }}>
              No products found for men.
            </p>
          )}

          {/* ✅ H2: Why Choose Our Men Products */}
          <h2 className="section-subtitle">Why Choose LushDesire Men Products?</h2>
          <p>
            Our men pleasure products are crafted from premium, body-safe materials, offering realistic sensations and unmatched comfort. All products are shipped with 100% discreet packaging and fast delivery across India.
          </p>
        </div>
      </section>

      {/* ✅ Features, Reviews & Blog Sections */}
      <FeaturesSection />
      <ReviewSlider />
      <BlogSection />
    </>
  );
};

export default ForMen;
